{
  "language-selection-dialog": {
    "buttons": {
      "close": "Close"
    },
    "text": {
      "title": "Language selection",
      "hint": "Select the language to display"
    }
  }
}
